<!-- App.vue -->
<template>
  <div class="landing-page" id="app">
    <Header
      :isScrolled="isScrolled"
      :language="language"
      :lMessages="lMessages['header']"
    />
    <Hero :lMessages="lMessages['hero']" :dMessages="lMessages['demo']" />
    <Products :lMessages="lMessages['products']" />
    <Platform :language="language" :lMessages="lMessages['platform']" />
    <AboutUs :lMessages="lMessages['aboutUs']" />
    <Footer :lMessages="lMessages['footer']" />
  </div>
</template>

<script>
import AboutUs from "@/components/landing/AboutUs.vue";
import Footer from "@/components/landing/Footer.vue";
import Header from "@/components/landing/Header.vue";
import Hero from "@/components/landing/Hero.vue";
import Platform from "@/components/landing/Platform.vue";
import Products from "@/components/landing/Products.vue";
import { landingMessages } from "@/_core/data/Landing";

export default {
  name: "App",
  components: {
    AboutUs,
    Footer,
    Header,
    Hero,
    Platform,
    Products
  },
  data() {
    return {
      availableLanguages: ["en", "es"],
      isScrolled: false,
      language: "en",
      lMessages: ""
    };
  },
  watch: {
    "$route.params.lang": {
      immediate: true,
      handler(newLang) {
        this.language = newLang;
        this.lMessages = landingMessages[newLang];
      }
    }
  },
  created() {
    if (this.availableLanguages.includes(this.$route.params.lang)) {
      this.language = this.$route.params.lang;
    } else {
      this.language = "en";
    }
    this.lMessages = landingMessages[this.language];
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    }
  }
};
</script>

<style scoped>
@font-face {
  font-family: "Akzidenz Grotesk BQ";
  src: url("../assets/fonts/AkzidenzGroteskBQ-Light.woff2") format("woff2"),
    url("../assets/fonts/AkzidenzGroteskBQ-Light.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
.landing-page {
  font-family: "Akzidenz Grotesk BQ", sans-serif;
}
</style>
